<template>
  <div id="pay-gate">
    <div class="tab-header">
      <slot name="header"></slot>
    </div>
    <div class="tab-content">
      <label class="label-title">
        {{ $t("PAY_GATE") }}:
        <slot name="subheader"></slot>
      </label>

      <div class="row" v-if="typeof data != 'string'">
        <div class="col-lg-6" v-for="(item, i) in data.params" :key="i">
          <label class="label-input">{{ item.key }} *</label>
          <input-text :model.sync="item.value" :error.sync="errorList[i]" :disabled="isOnsite" />
        </div>
      </div>
      <div v-else>
        <span>{{ $t(data) }}</span>
      </div>
      <div class="btn-bottom">
        <button class="btn btn-back mr-5" @click="back">
          {{ $t("BACK") }}
        </button>
        <button class="btn btn-save" @click="save" :disabled="isOnsite">{{ $t("SAVE") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import { PG_SETTING_ERROR } from "@/_helpers/config.js";
import { _validateFormI18n, _resetErrorState, _alert } from "@/_helpers/function.js";
import { service } from "@/_services/HotelSetting/payment-gate.service.js";
export default {
  components: {
    "input-text": Input
  },
  props: {
    data: [Array, String],
    isOnsite: Boolean,
  },
  data() {
    return {
      tempData: {},
      error: {},
      errorList: []
    };
  },
  created() {
    // console.log(this.data)
    document.documentElement.scrollTop = 0;
    _resetErrorState(this.error);
    if (typeof this.data.params == "string") {
      return false;
    }
    this.data.params.forEach(x => {
      this.error[x.key] = {
        error: null,
        required: true
      };
    });
  },
  methods: {
    back() {
      this.$emit("backToParent");
    },
   async save() {
      let temp = {};
      this.data.params.forEach(x => {
        temp[x.key] = x.value;
      });
      let { isValid, error } = _validateFormI18n(temp, this.error);
      this.errorList = Object.keys(this.error).map(x => this.error[x].error);
      if (!isValid) return false;
      const body = {
        code: this.data.code,
        name: this.data.name,
        params: this.data.params
      };
       await service.updateParam(body).then(res => {
        _alert(res, this.$t(res.data));
      });
      
    },
    validate() {
      let isValid = true;
      return isValid;
    }
  }
};
</script>
